module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-top": "200px"
    },
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('p', [_c('em', [_vm._v("Where do words come from?")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("from what rubbing of sounds are they born")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("on what flint do they light their wicks")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("what winds brought them into our mouths?")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('em', [_vm._v("—Words")]), _vm._v(" by Venus Khoury-Ghata")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd9ffbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 72
// module chunks = 0